import React, { useState, useEffect } from 'react';
import { Spin, message } from 'antd';
import { Chart } from 'react-google-charts';
import PropertyWithModal from '../environmental/PropertyWithModal';
import { getRecommendation } from '../../data/Data';

const PurityIndex = ({ dataFetcher }) => {
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [purityIndexRecommendation, setPurityIndexRecommendation] = useState({recommendation: {}});


    useEffect(() => {
        const fetchData = async () => {
        try {
            const data = await dataFetcher();
            const formattedData = [
                ['Label', 'Value'], // Google Charts requires a header row
                ...data,
            ];
            setChartData(formattedData);
            setLoading(false);

            //Recommendation
            const value = data[0][1];
            const rec = getRecommendation(data[0][0], value);
            setPurityIndexRecommendation({recommendation: rec});
        } catch (err) {
            message.error(err.message || "Failed to fetch data.");
            setLoading(false);
        }
        };

        fetchData();
    }, [dataFetcher]);


    return (
        <Spin spinning={loading} size="large">
            <div style={{ marginBottom: '12px', backgroundColor: '#FFF', paddingTop: 14, paddingLeft: 14 }}>
                <h3 style={{ marginBottom: '4px' }}>
                    <PropertyWithModal property={'Purity Index'} details={purityIndexRecommendation} />
                </h3>
                <div style={{ maxWidth: '100%' }}>
                    <Chart
                        chartType="PieChart"
                        //width="100%"
                        height="400px"
                        data={chartData}
                        options={{ 
                            is3D: true,
                            legend: {
                                position: "top",
                                alignment: "end",
                                textStyle: {
                                    color: "#233238",
                                    fontSize: 14,
                                },
                            }, 
                        }}
                    />   
                </div> 
            </div>
        </Spin>
    );
}

export default PurityIndex;
